<template>
    <modal @close="closeFromModal" style="overflow: auto" :modalContainerStyle="`overflow: visible`">
        <template #header>
            <h5>{{ $tl("labels.booking.reservations.noshowStatus", restaurant_id) }}</h5>
        </template>
        <template #body>
            <set-noshow
                :restaurant_id="restaurant_id"
                :reservation_id="reservation.id"
                :showSaveButton="false"
                v-on:noShowTaken="noShowTaken"
                :ref="`setNoshow`" />
        </template>
        <template #footer>
            <div class="d-flex w-100 justify-content-between">
                <button class="ms-5 btn btn-secondary btn-circle btn btn-sm" @click="$emit('close')">Annuler</button>
                <div class="d-flex me-5">
                    <div tabindex="-1" :ref="`dropdown-main`" class="dropdown" v-if="reservation.client && reservation.chargable_if_no_show">
                        <button
                            class="btn-sm btn-danger btn-circle btn dropdown-toggle"
                            type="button"
                            id="dropdownMenu2"
                            ref="deductionDropdown"
                            data-bs-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false">
                            Prélever
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                            <template v-if="isNoShowAmountPerBooking">
                                <button
                                    @click="takeNoShow(totalNbPers)"
                                    class="dropdown-item"
                                    type="button"
                                    :disabled="reservation.amount_if_noshow > stripeIntentAmount">
                                    Réservation ({{ reservation.amount_if_noshow / 100 }}€)
                                </button>
                            </template>
                            <template v-else-if="reservation.payment.card_system_type === CARD_PAYMENT_SYSTEM_STRIPE.value">
                                <button
                                    v-for="n in totalNbPers"
                                    :key="n"
                                    @click="takeNoShow(n)"
                                    class="dropdown-item"
                                    type="button"
                                    :disabled="n * reservation.amount_if_noshow > stripeIntentAmount">
                                    {{ n }} personne(s) ({{ (n * reservation.amount_if_noshow) / 100 }}€)
                                </button>
                            </template>
                            <button
                                v-else
                                @click="takeNoShow(totalNbPers)"
                                class="dropdown-item"
                                type="button"
                                :disabled="totalNbPers * reservation.amount_if_noshow > stripeIntentAmount">
                                {{ totalNbPers }} personne(s) ({{ (totalNbPers * reservation.amount_if_noshow) / 100 }}€)
                            </button>
                        </div>
                    </div>
                    <button @click="markNoShow" class="ms-2 btn btn-sm btn-warning btn-circle text-white">
                        {{ $tl("labels.booking.reservations.noshowWithoutDeduction", restaurant_id) }}
                    </button>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import { Dropdown } from "bootstrap";
import SetNoshow from "../../reservations/setNoshow.vue";
import CardPaymentSystemTypeEnum from "../../../mixins/enums/CardPaymentSystemEnum";

export default {
    props: {
        restaurant_id: {
            required: true,
        },
        reservation: {
            required: true,
        },
    },
    mixins: [CardPaymentSystemTypeEnum],
    components: {
        SetNoshow,
    },
    computed: {
        totalNbPers() {
            return this.reservation.nb_pers + this.reservation.nb_children;
        },
        stripeIntentAmount() {
            return this.reservation.stripe_intent_amount || this.reservation.payment?.stripe_intent_amount || 0;
        },
        isNoShowAmountPerBooking() {
            return this.reservation.amount_if_noshow_mode === "per_booking";
        },
    },
    mounted() {
        if (this.$refs.deductionDropdown) {
            Dropdown.getOrCreateInstance(this.$refs.deductionDropdown);
        }
    },
    beforeUnmount() {
        if (this.$refs.deductionDropdown) {
            Dropdown.getInstance(this.$refs.deductionDropdown)?.dispose();
        }
    },
    methods: {
        takeNoShow(nb_people) {
            this.$refs["setNoshow"]
                .takeNoShow(nb_people)
                .then(() => {
                    this.notifySuccess(null, this.$tl("success.booking.reservations.updated"));

                    this.close();
                })
                .catch((error) => {
                    this.notifyError(error);

                    this.$refs["setNoshow"].setLoading(false);
                });
        },
        noShowTaken() {
            this.location.reload(true);
        },
        markNoShow() {
            this.$refs["setNoshow"]
                .markNoShow()
                .then(() => {
                    this.notifySuccess(null, this.$tl("success.booking.reservations.updated"));

                    this.close();
                })
                .catch((error) => {
                    this.notifyError(error);

                    this.$refs["setNoshow"].setLoading(false);
                });
        },
        close() {
            this.$emit("close");
        },
        closeFromModal: function (e) {
            if (e && e.target && !e.target.classList.contains("modal-wrapper")) {
                e.stopPropagation();
            } else {
                this.close();
            }
        },
    },
};
</script>
